export const environment = {
  DEFAULT_LANG: 'es',
  apiUrl: 'https://admin.beco.tools/api/v1/finance/',
  loginApiUrl: 'https://admin.beco.tools/api/finance/',
  apiUrl2: 'https://admin.beco.tools/api/v1/cp/',
  mockUrl: 'https://705518a1-e139-4a15-b97a-9652702511bc.mock.pstmn.io',
  production: false,
};
